"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    // Next.js sometimes struggles to scroll to the top of the page on route changes
    // when html { scroll-behavior: smooth } is set in CSS. 
    // This forces an instant scroll to the top whenever the route path changes.
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname]);

  return null;
}
